import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Router } from '@angular/router';
import { BiometricConsentRequest } from 'src/app/core/dtos/dto';


@Component({
  selector: 'app-biometric-consent',
  templateUrl: './biometric-consent.component.html',
  styleUrls: ['./biometric-consent.component.scss']
})
export class BiometricConsentComponent implements OnInit, OnDestroy {

  setConsentSubscription: Subscription;

  constructor(
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  goNext(biometricConsentRequest: BiometricConsentRequest) {
    this.setConsentSubscription = this.registrationService.setBiometricConsent(biometricConsentRequest)
      .subscribe(
        () => {
          this.router.navigate(['my-account']);
        },
        () => this.toastService.warning("Failed to save biometric consent.")
      );
  }

  ngOnDestroy() {
  }
}
